import { render, staticRenderFns } from "./AttributeHistoryModal.vue?vue&type=template&id=f27cdbcc&scoped=true"
import script from "./AttributeHistoryModal.vue?vue&type=script&lang=ts"
export * from "./AttributeHistoryModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f27cdbcc",
  null
  
)

export default component.exports